var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-2 info_field",class:("info_field--" + _vm.variant)},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }